import { render, staticRenderFns } from "./PlatformDeleteModal.vue?vue&type=template&id=13e1c63e"
import script from "./PlatformDeleteModal.vue?vue&type=script&lang=js"
export * from "./PlatformDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports